import { CommonModule } from '@angular/common';
import { Component, inject, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgSelectModule } from '@ng-select/ng-select';
import { QuillModule } from 'ngx-quill';
import { Api } from '../../services/api';

@Component({
  selector: 'app-mdl-manage-campaign',
  imports: [FormsModule, CommonModule, QuillModule, NgSelectModule],
  templateUrl: './mdl-manage-campaign.html',
  styleUrl: './mdl-manage-campaign.css'
})
export class MdlManageCampaign implements OnInit{
  private api = inject(Api);
  public estados: any = [];
  contenido = '';
  tipoEnvio: string = 'now';
  public segments: any = [];
  minDate: string = '';

  fechaEnvio: Date = new Date();

  public request: any = {
    nombre_campana: '',
    estado_id: '',
    segmento_id: '',
    tipo_envio: '',
    from: 'info@soportesiroe.cl',
    asunto: '',
    contenido: '',
    cc: '',
    fecha_envio: this.fechaEnvio
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public mdl: MatDialogRef<MdlManageCampaign>,
  ) { 

  }

  ngOnInit(): void {
    this.getCampaignStatus();
    this.getSegments();

  const today = new Date();
  const year = today.getFullYear();
  const month = (today.getMonth() + 1).toString().padStart(2, '0');
  const day = today.getDate().toString().padStart(2, '0');
  this.minDate = `${year}-${month}-${day}`;

  }

  createCampaign(): void {
    this.api.showLoading();
    if (this.tipoEnvio === 'scheduled') {
    const fecha = this.request.fecha_envio_fecha;
    const hora = this.request.fecha_envio_hora || '00:00';
    this.request.fecha_envio = `${fecha}T${hora}:00`;
  } else {
    this.request.fecha_envio = new Date().toISOString();
  }

  this.request.tipo_envio = this.tipoEnvio;
    console.log('Datos de la campaña a agregar:', this.request);
    this.api.createCampaign(this.request).subscribe({
      next: (resp: any) => {
        console.log('Campaña creada con éxito:', resp);
        this.api.hideLoading();
        this.mdl.close(true); // Cerrar el modal y pasar true para indicar éxito
      },
      error: (err: any) => {
        this.api.hideLoading();
        console.error('Error al crear la campaña:', err);
      }
    });
  }

  getSegments(): void {
    this.api.getSegmentos().subscribe({
      next: (resp: any) => {
        this.segments = resp.segmentos;
        console.log('Segmentos obtenidos:', this.segments);
      },
      error: (err: any) => {
        this.api.hideLoading();
        console.error('Error al obtener los segmentos:', err);
      }
    });
  }

  getCampaignStatus(): void {
      this.api.getStatusByType({tipo: 'CMP'}).subscribe({
       next: (resp: any) => {
          this.estados = resp.data;
       },
       error: (err: any) => {
         console.error('Error al obtener los estados de campaña:', err);
       }
      }
    );
  }

  // Configuración personalizada (opcional)
  quillConfig = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'align': [] }],
      ['link', 'image']
    ]
  };

  onContentChanged(event: any) {
    console.log('Contenido cambiado:', event.html);
  }

  onEditorCreated(event: any) {
    console.log('Editor creado:', event);
  }

  // Obtener solo el texto sin HTML
  obtenerTextoPlano() {
    const temp = document.createElement('div');
    temp.innerHTML = this.contenido;
    return temp.textContent || temp.innerText || '';
  }

  leerData() {
    const textoPlano = this.obtenerTextoPlano();
    console.log('Texto plano:', textoPlano);
  }

  closeMdl(): void {
    this.mdl.close();
  }

  getEnvio(): void {
    console.log('Tipo de envío seleccionado:', this.tipoEnvio);
  }

  onTipoEnvioChange(): void {
  this.request.tipo_envio = this.tipoEnvio;

  if (this.tipoEnvio === 'scheduled') {
    console.log('🟢 Envío programado: campos habilitados');
  } else {
    console.log('🔵 Envío inmediato: campos deshabilitados');
    this.request.fecha_envio_fecha = '';
    this.request.fecha_envio_hora = '';
  }
}
}
